import { defineMessages } from 'react-intl';

export default defineMessages({
  employeeList: {
    id: 'employee.list',
    defaultMessage: 'Employee List',
  },
  viewDetail: {
    id: 'employee.table.value.view_details',
    defaultMessage: 'View Detail',
  },
  no: {
    id: 'employee.table.label.no',
    defaultMessage: 'No',
  },
  employeeId: {
    id: 'employee.table.label.employeeId',
    defaultMessage: 'Employee ID',
  },
  employeeName: {
    id: 'employee.table.label.employeeName',
    defaultMessage: 'Employee Name',
  },
  companyName: {
    id: 'employee.table.label.companyName',
    defaultMessage: 'Company Name',
  },
  email: {
    id: 'employee.table.label.email',
    defaultMessage: 'Employee Email',
  },
  role: {
    id: 'employee.table.label.role',
    defaultMessage: 'Employee Role',
  },
  ktp: {
    id: 'employee.table.label.employeeKtp',
    defaultMessage: 'Employee ID Card (KTP) Number',
  },
  action: {
    id: 'employee.table.label.action',
    defaultMessage: 'Action',
  },
  btnRegister: {
    id: 'employee.btn.registerNewEmployee',
    defaultMessage: 'Register New Employee',
  },
  inputPlaceholder: {
    id: 'employee.search.placeholder',
    defaultMessage: 'Employee Name',
  },
  currentStatus: {
    id: 'employee.table.label.currentStatus',
    defaultMessage: 'Current Status',
  },
  notifActivatedSuccess: {
    id: 'employee.list.notif.activated.success',
    defaultMessage: 'Activated Success',
  },
  notifDeactivatedSuccess: {
    id: 'employee.list.notif.deactivated.success',
    defaultMessage: 'Deactivated Success',
  },
});
